"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _styles = require("./styles");

var _jsxRuntime = require("react/jsx-runtime");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const PerformanceChartIcon = ({
  title,
  ...otherProps
}) => /*#__PURE__*/(0, _jsxRuntime.jsxs)("svg", { ...otherProps,
  width: "110",
  height: "110",
  viewBox: "0 0 110 110",
  xmlns: "http://www.w3.org/2000/svg",
  children: [title && /*#__PURE__*/(0, _jsxRuntime.jsx)("title", {
    children: title
  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
    fill: "none",
    fillRule: "evenodd",
    children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
      transform: "translate(-555 -489) translate(515 396) translate(40 93) translate(23 29)",
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
        stroke: "#9B9EA0",
        strokeDasharray: "2,4",
        strokeLinecap: "round",
        d: "M5 51v-8M23 51V28",
        className: "svg-stroke-secondary"
      }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
        stroke: "#4DAA50",
        strokeLinecap: "round",
        transform: "translate(19.5)",
        className: "svg-stroke-primary",
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
          d: "M3.5 8V0M39.5 14V6"
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
          strokeLinejoin: "round",
          d: "M6.5 3L3.5 0 0.5 3"
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
          strokeLinejoin: "round",
          d: "M42.5 9L39.5 6 36.5 9"
        })]
      }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
        strokeLinecap: "round",
        transform: "matrix(1 0 0 -1 38 16)",
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
          stroke: "#9B9EA0",
          d: "M3 8V0",
          className: "svg-stroke-secondary"
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
          stroke: "#979797",
          strokeLinejoin: "round",
          d: "M6 3L3 0 -9.09494702e-13 3",
          className: "svg-stroke-secondary"
        })]
      }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
        strokeLinecap: "round",
        transform: "matrix(1 0 0 -1 2 22)",
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
          stroke: "#9B9EA0",
          d: "M3 8V0",
          className: "svg-stroke-secondary"
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
          stroke: "#979797",
          strokeLinejoin: "round",
          d: "M6 3L3 0 -9.09494702e-13 3",
          className: "svg-stroke-secondary"
        })]
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
        stroke: "#9B9EA0",
        strokeDasharray: "2,4",
        strokeLinecap: "round",
        d: "M41 51V35M59 51V29",
        className: "svg-stroke-secondary"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("circle", {
        cx: "5",
        cy: "33",
        r: "5",
        stroke: "#FFF",
        strokeWidth: "3",
        className: "svg-stroke-secondary"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
        stroke: "#FFF",
        strokeWidth: "2",
        d: "M10 30l10-8.625",
        className: "svg-stroke-secondary"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("circle", {
        cx: "23",
        cy: "19",
        r: "5",
        stroke: "#FFF",
        strokeWidth: "3",
        className: "svg-stroke-secondary"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("circle", {
        cx: "41",
        cy: "27",
        r: "5",
        stroke: "#FFF",
        strokeWidth: "3",
        className: "svg-stroke-secondary"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
        stroke: "#FFF",
        strokeWidth: "2",
        d: "M27 21l9 4M45 27l9-1.312",
        className: "svg-stroke-secondary"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("circle", {
        cx: "59",
        cy: "25",
        r: "5",
        stroke: "#FFF",
        strokeWidth: "3",
        className: "svg-stroke-secondary"
      })]
    })
  })]
});

PerformanceChartIcon.defaultProps = {
  title: undefined
};

var _default = (0, _styles.colourIcon)(PerformanceChartIcon);

exports.default = _default;